import dynamic from 'next/dynamic';

import { RoktPlacementProps } from './RoktPlacement.types';

export type { RoktPlacementProps, RoktIdentityDetails } from './RoktPlacement.types';
export {
  DEFAULT_ROKT_PLACEMENT_DIV_ID,
  DEFAULT_ROKT_PLACEMENT_IDENTIFIER,
} from './roktPlacement.constants';
export { buildRoktPlacementAttributes } from './roktPlacement.utils';
export {
  clearRoktSessionData,
  getRoktIdentityFromSession,
  hashEmailSha256,
  setRoktGuestSessionData,
} from '../../utils/rokt/roktUtils';

export const RoktPlacement = dynamic<RoktPlacementProps>(() =>
  import('./RoktPlacement').then(module => module.RoktPlacement)
);